// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fTby","clinicsSelect":"styles_clinicsSelect__k15AM"};